export enum NavStatusEnum {
  PENDING = 'PENDING',
  COMPLETE = 'COMPLETE',
  ACTIVE = 'ACTIVE',
  ALERT = 'ALERT',
}
